import { render, staticRenderFns } from "./CheckBoxes.vue?vue&type=template&id=5dd27106&scoped=true&"
import script from "./CheckBoxes.vue?vue&type=script&lang=js&"
export * from "./CheckBoxes.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxes.vue?vue&type=style&index=0&id=5dd27106&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd27106",
  null
  
)

export default component.exports